import { render } from "./TemplateZones.vue?vue&type=template&id=433d0a7c&scoped=true"
import script from "./TemplateZones.vue?vue&type=script&lang=js"
export * from "./TemplateZones.vue?vue&type=script&lang=js"

import "./TemplateZones.vue?vue&type=style&index=0&id=433d0a7c&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433d0a7c"]])

export default __exports__